import { Button } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import CustomLoader from '../../CustomComponents/loader/CustomLoader'
import HttpClient from '../../utils/HttpClient'
import toast from 'react-hot-toast'
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon'
import { DeleteConfirmModal } from '../../CustomComponents/DeleteConfirmModal'
import { ImCross } from 'react-icons/im'
import moment from 'moment'

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "35px",
    fontWeight: "bold"

}

const HomePageBackground = () => {
    const fileInputRef = useRef(null)
    const initData = {
        image: "",
    }
    const [formData, setFormData] = useState(initData)
    const [AllData, setAllData] = useState([]);
    const [isLoading, setisLoading] = useState(false)
    const [editID, setEditID] = useState("")
    const [showEdit,setShowEdit]=useState(false)


    // select the Image
    const handleChange = async (e) => {
        setisLoading(true)
        const { name, files } = e.target;
        if (files && files.length > 0) {
            // File is selected, perform image upload
            const formData = new FormData();
            formData.append("image", files[0]);
            const res = await HttpClient.fileUplode("image-upload", "POST", formData);
            if (res && res.status) {
                setFormData(prev => ({
                    ...prev,
                    [name]: res?.data?.url
                }));
                setisLoading(false)
                setShowEdit(true)
            }
        }
    };

    const viewData = async () => {
        setisLoading(true);
        const res = await HttpClient.requestData("home-background", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setisLoading(false);
            setFormData(prev => ({
                ...prev,
                image: res?.data[0]?.image,
            }))
            setEditID(res?.data[0]?._id)
        }
        else {
            setisLoading(false);
        }
        setAllData(apiData);
    }
 

 

    //cancel edit
    const cancelEdit = (e) => {
        setShowEdit(false)
        viewData()
    }

    //Edit Submit
    const handleUpdate = async (e) => {
        e.preventDefault()
        if(!editID){
            return toast.error("No image found!")
        }
        if (!formData?.image) {
            return toast.error("No image choosen!")
        }

        const res = await HttpClient.requestData(`home-background/${editID}`, 'PUT',formData)

        if (res && res?.status) {
            toast.success("Updated Successfully")
            setisLoading(false)
            viewData()
            setFormData(initData)
            setShowEdit(false)
            fileInputRef.current.value = null
        }
        else {
            setisLoading(false)
            toast.error(res?.message || "Something Wrong");
            setisLoading(false);
            viewData()
        }
    }
    useEffect(() => {
        viewData();
    }, [])


    return (
        <div>

            <CustomLoader
                loading={isLoading}
            />
            <div className="d-flex justify-content-end">

                <div className="form-header">
                    <section className="piechartsBox_area">
                        <div
                            style={headLineStyle}
                            className="page-headline"
                        >
                            Home Page Background Image
                        </div>
                        <form >
                            <div className="row">
                                <div className="col-md-12 mt-3 ">
                                    <label style={{ marginRight: "22px", display: "block" }}>Background Image: <span style={{ color: "red" }}>(1320 x 744)</span></label>
                                    {formData?.image && <img src={formData?.image} alt="" id='preview' className='mb-2'
                                        style={{ width: "100%" }}
                                    />}
                                    <input
                                        type="file"
                                        className="mx-1"
                                        placeholder="Background Image"
                                        name="image"
                                        onChange={(e) => handleChange(e)}
                                        required
                                        style={{ display: "block" }}
                                        ref={fileInputRef}
                                    />

                                </div>





                            </div>

                            {showEdit &&

                                <div>
                                    <Button variant="contained" color="primary" className='mx-2 mt-2' onClick={(e) => handleUpdate(e)}>
                                        Update
                                    </Button>    <ImCross
                                        onClick={(e) => cancelEdit(e)}
                                        style={{ fontSize: "20px", cursor: "pointer" }} className=" mx-3 mt-4 text-danger " />
                                </div>
                            }
                        </form>

                    </section>
                </div>

            </div >




        </div >
    )
}

export default HomePageBackground